var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgErrorIcon = function SvgErrorIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41,
    height: 38,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#252525",
    strokeWidth: 1.5,
    d: "M7.7 14.559c4.626-8.186 6.94-12.28 10.113-13.333a8.52 8.52 0 0 1 5.374 0C26.36 2.28 28.674 6.373 33.3 14.56s6.94 12.279 6.246 15.614a8.93 8.93 0 0 1-2.687 4.754c-2.48 2.281-7.107 2.281-16.359 2.281s-13.879 0-16.359-2.281a8.93 8.93 0 0 1-2.686-4.754C.76 26.838 3.074 22.745 7.7 14.559Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#252525",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M20.485 26.667h.017"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#252525",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M20.5 20.917V13.25"
  })));
};
export default SvgErrorIcon;